import { StatusChip as RawStatusChip } from 'components/Chips/StatusChip'
import { StatusChipProps } from './types'
import { chipColors } from './utils/chipColors'

export const StatusChip = ({ status }: StatusChipProps): JSX.Element => {
  return <RawStatusChip {...{ chipColors, status }} />
}
